import React, { type FC } from 'react';

type ContainerHeaderTextProps = {
    headerText: string;
};

const ContainerHeaderText: FC<ContainerHeaderTextProps> = ({ headerText, ...props }) => (
    <p 
        className="w-full pb-2 text-left font-gilroy text-2xs font-normal leading-5 text-grey-600" 
        {...props}
    >
        {headerText}
    </p>
);

export default ContainerHeaderText;
